<template>
	<div>
		<b-modal ref="modal" hide-footer @hidden="skip(false)">
	        <template v-slot:modal-title>
	       		{{ $t("invoice.cc_avoir_non_solde") }}
	        </template>

			<LoadingSpinner v-if="processing" text_trad="invoice.creation_payment" />
	        <template v-else>
		        <div v-for="invoice in invoices" class="border-bottom mb-3" :key="invoice.tiers_id">
			       	<router-link :to="{ name: 'tiersFiche', params: { tiers_id: invoice.tiers_id }}"><u><b>{{ invoice.tiers_rs }}</b></u></router-link>
		    		<table class="mt-2" >
		    			<tr v-if="invoice.current_account.amount">
			    			<td class="pt-2">
			    				<b-form-checkbox v-model="invoice.current_account.checked" @input="updateBalance(invoice.invoice_id)" />
			    			</td>
			    			<td class="px-2 pt-2">
			    				{{ $t('payment.compte_courant') }}
			    			</td>
			    			<td class="pt-2">
			    				{{ invoice.current_account.amount_format }}
			    			</td>
		    			</tr>
		    			<tr v-for="avoir in invoice.avoirs" :key="avoir.invoice_id">
			    			<td class="pt-2">
			    				<b-form-checkbox v-model="avoir.checked" @input="updateBalance(invoice.invoice_id)" />
			    			</td>
			    			<td class="px-2 pt-2">
			    				{{ $t('action.only_avoir') }} <a href="" @click.prevent="preview(avoir.invoice_id)"><u>{{ avoir.invoice_num }} <font-awesome-icon :icon="['fas', 'eye']" /></u></a>
			    			</td>
			    			<td class="pt-2">
			    				{{ avoir.invoice_balance_format }}
			    			</td>
			    		</tr>
		    		</table>
					<div class="w-100 text-right my-3">
						{{ $t('invoice.appliquer') }} {{ invoice.sum_selected }} {{ $t('invoice.on_facture') }} <a href="" @click.prevent="preview(invoice.invoice_id)"><u>{{ invoice.invoice_num }} <font-awesome-icon :icon="['fas', 'eye']" /></u></a>, {{ $t('invoice.solde_passera') }} <br/>{{ invoice.invoice_balance_format }} {{ $t('global.a') }} {{ invoice.invoice_balance_remaining }}
					</div>
		        </div>
		        <div class="row align-items-center">
		        	<div class="col-auto">
		        		<a href="" @click.prevent="skip(false)">{{ $t('invoice.skip_etape') }}</a>
		        	</div>
		        	<div class="col text-right">
		        		<b-button variant="primary" rounded @click="submit">{{ $t('invoice.apply_sum_selected') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" /></b-button>
		        	</div>
		        </div>
		    </template>
	    </b-modal>

        <b-modal size="xl" ref="modal_preview" hide-footer @hidden="base64 = null">
            <template v-slot:modal-title>
                {{ $t("action.previsualiser") }}
            </template>

            <iframe v-if="base64 != null" :src="'data:application/pdf;base64,' + base64" height="1000px" width="100%" style="position:relative"></iframe>
            <div v-else>
                <LoadingSpinner />
            </div>
        </b-modal>
	</div>
</template>

<script type="text/javascript">
    import Tiers from "@/mixins/Tiers.js"
    import Navigation from "@/mixins/Navigation.js"
    import Payment from "@/mixins/Payment.js"
    import Invoice from "@/mixins/Invoice.js"
    import { EventBus } from "EventBus"
	import Common from '@/assets/js/common'

	export default {
		name: 'ModalAvoirCC',
		mixins: [Tiers, Navigation, Payment, Invoice],
		props: ['callback'],
		data () {
			return {
				invoices: [],
				base64: null,
				processing: false
			}
		},

		methods: {
			async init_component(invoices) {
				this.invoices = []
				await Common.asyncForEach(invoices, async invoice => {
					if(invoice.invoice_balance < 0) {
						return false
					}

					const invoices_tiers = await this.loadAllInvoicesByTiers(invoice.invoice_tiers)
					const avoirs = invoices_tiers.filter(invoice => invoice.invoice_balance < 0 && invoice.invoice_accountingplan == invoice.invoice_accountingplan)

					let current_account = await this.loadCurrentAccount(invoice.invoice_tiers, true)
					current_account = current_account[invoice.invoice_accountingplan]

					if(avoirs.length > 0 || (current_account && current_account.balance > 0)) {
						let remaining = invoice.invoice_balance*100
						let current_account_format = null
						if(current_account && current_account.balance > 0) {
							remaining -= current_account.balance
							current_account_format = await this.priceFormat(current_account.balance / 100, current_account.currency, true)
						}

						await Common.asyncForEach(avoirs, async avoir => {
							avoir.invoice_balance_format = await this.priceFormat(avoir.invoice_balance*-1, avoir.author.tiers_currency, true)
							avoir.checked = false
							if(remaining > 0) {
								avoir.checked = true
								remaining -= avoir.invoice_balance*-100
							}
						})

						const balance = await this.priceFormat(invoice.invoice_balance, invoice.author.tiers_currency, true)

						this.invoices.push({
							tiers_id: invoice.invoice_tiers,
							tiers_rs: invoice.tiers.tiers_rs,
							currency: invoice.author.tiers_currency,
							invoice_id: invoice.invoice_id,
							invoice_num: invoice.invoice_num,
							invoice_date: invoice.invoice_date,
							invoice_balance: invoice.invoice_balance,
							invoice_balance_format: balance,
							invoice_balance_remaining: balance,
							avoirs,
							current_account: {
								amount: (current_account && current_account.balance > 0) ? current_account.balance / 100 : null,
								amount_format: current_account_format,
								checked: !!current_account
							}
						})

						this.updateBalance(invoice.invoice_id)
					}
				})
				if(this.invoices.length == 0) {
					this.skip()
				}
				else {
					this.$refs.modal.show()
				}
			},

			async updateBalance(invoice_id) {
				const index = this.invoices.findIndex(invoice => invoice.invoice_id == invoice_id)
				const invoice = this.invoices[index]

				let balance = invoice.invoice_balance
				if(invoice.current_account.checked) {
					balance -= invoice.current_account.amount
				}

				const avoirs = this.invoices[index].avoirs.filter(invoice => invoice.checked)
				balance += avoirs.reduce((sum, invoice) => sum + invoice.invoice_balance, 0)

				if(balance < 0) {
					balance = 0
				}

				this.invoices[index].invoice_balance_remaining = await this.priceFormat(balance, invoice.currency, true)
			},

			async preview(invoice_id) {
                this.$refs.modal_preview.show()
                let retour = await this.pdfInvoice([invoice_id], "", true)
                if(retour) {
                    this.base64 = retour
                }
			},

			skip(reload = false) {
				this.$refs.modal.hide()
				this.callback(reload)
			},

			async submit() {
				this.processing = true
				const payment_methods = this.getConfig('payment_method')
				const payment_cc = payment_methods.find(p => p.paymentmethod_code == 'CC').paymentmethod_id
				await Common.asyncForEach(this.invoices, async invoice => {
					const avoirs = invoice.avoirs.filter(invoice => invoice.checked)
					const avoirs_ids = avoirs.map(avoir => avoir.invoice_id)
					const sum_avoirs = avoirs.reduce((sum, invoice) => sum + invoice.invoice_balance, 0)

					let current_account = 0
					let balance_cc = invoice.invoice_balance

					if(invoice.current_account.checked) {
						current_account = invoice.current_account.amount
					}

					if(current_account > 0) {
						balance_cc = current_account - invoice.invoice_balance
						// si le restant du CC est > à 0 alors je peux solder entièrement ma facture avec le CC
						if(balance_cc >= 0) {
							await this.createPayment({
								invoice_ids: [invoice.invoice_id],
								payment_amount: invoice.invoice_balance,
								payment_date: invoice.invoice_date,
								payment_method: payment_cc,
								tiers_id: invoice.tiers_id,
							})
							return
						}
					}

					// si je n'ai pas d'avoirs sélectionnés
					if(avoirs.length == 0) {
						if(current_account > 0) {
							await this.createPayment({
								invoice_ids: [invoice.invoice_id],
								payment_amount: current_account,
								payment_date: invoice.invoice_date,
								payment_method: payment_cc,
								tiers_id: invoice.tiers_id,
							})
						}
						return
					}

					// je calcule le restant à payer avec les avoirs
					let balance_avoirs = (Math.abs(balance_cc) * 100 - Math.abs(sum_avoirs) * 100) / 100
					let payment_avoirs = balance_avoirs >= 0 ? sum_avoirs : balance_cc
					let payment_amount = current_account + Math.abs(payment_avoirs)

					// j'ajoute un règlement sur mes avoirs que j'ajoute dans le CC
					await this.createPayment({
						invoice_ids: avoirs_ids,
						payment_amount: Math.abs(payment_avoirs)*-1,
						payment_date: invoice.invoice_date,
						payment_method: payment_cc,
						tiers_id: invoice.tiers_id,
					})

					// je solde ma facture avec le CC
					await this.createPayment({
						invoice_ids: [invoice.invoice_id],
						payment_amount: payment_amount,
						payment_date: invoice.invoice_date,
						payment_method: payment_cc,
						tiers_id: invoice.tiers_id,
					})
				})
				this.processing = false

				this.skip(true)
			}
		},

		components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
            LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>